module.exports = __webpack_public_path__ + "static/media/arrow_scroll_top.04c7f904.svg";